import Annotation from './components/Annotation'
export { default as defaultProps } from './components/defaultProps'

export default Annotation



// WEBPACK FOOTER //
// ./src/index.js